import type { PublicPageGuideStep } from "@/types";

/** localStorage flag: user dismissed the first-visit spaces guide */
export const SPACES_PAGE_GUIDE_STORAGE_KEY = "te_spaces_guide_v1";

export const SPACES_PAGE_LEDE =
  "Directorio de salas de teatro en Córdoba Capital. Buscá por nombre o dirección, filtrá por zona y contactá a cada espacio desde su tarjeta.";

export const SPACES_PAGE_GUIDE_TITLE = "¿Cómo funciona el directorio?";

export const SPACES_PAGE_GUIDE_INTRO =
  "Encontrá salas de la ciudad y contactá a cada espacio por su canal preferido.";

export const SPACES_PAGE_GUIDE_STEPS: readonly PublicPageGuideStep[] = [
  {
    icon: "search",
    title: "Buscá o filtrá",
    body: "Por nombre o dirección, o por zona. Conviene usar una u otra opción a la vez.",
  },
  {
    icon: "mapPin",
    title: "Revisá la tarjeta",
    body: "Dirección con mapa, contacto y redes de cada sala en un solo lugar.",
  },
  {
    icon: "message",
    title: "Escribiles directo",
    body: "Reserva y disponibilidad las coordina cada espacio.",
  },
] as const;

export const SPACES_PAGE_GUIDE_CONFIRM_LABEL = "Listo, explorar salas";

export const SPACES_PAGE_GUIDE_ACTION_TRACK_SUFFIX = "spaces_guide_dismiss";

export const SPACES_PAGE_EMPTY = {
  noData: "No hay salas en el directorio por ahora.",
  noMatch: "No encontramos salas con esos criterios.",
  hint: "Probá otra zona o borrá la búsqueda.",
  clearAction: "Ver todas las salas",
} as const;
